<!-- card-body_&:not(.no-margin-left) — вложенная карточка внутри app-card-body (было .card-body .card) -->
<div class="mb-5 overflow-hidden rounded-lg bg-card shadow-[var(--card-shadow)]
     [.card-body_&:not(.no-margin-left)]:ml-10 [.card-body_&:not(.no-margin-left)]:mt-5"
     [class.no-margin-left]="noMarginLeft()">
  <ng-content/>
</div>
